import React from 'react';

export const Notifications = (): React.ReactElement => <div>Coming soon</div>;
